import { render } from "./DepartmentPerformanceDetails.vue?vue&type=template&id=33a800fe&scoped=true"
import script from "./DepartmentPerformanceDetails.vue?vue&type=script&lang=js"
export * from "./DepartmentPerformanceDetails.vue?vue&type=script&lang=js"

import "./DepartmentPerformanceDetails.vue?vue&type=style&index=0&id=33a800fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a800fe"]])

export default __exports__